
// "How has this year been?" — step 7 of the AEP renewal wizard (#656,
// reference screenshots 13-14).
//
// Two deliberate departures from the reference designs, both settled on the
// issue: the platform asks a single "how's your plan working" question, but
// Flow stores `happy_medical` and `happy_prescription` separately and agents
// read both, so both are asked here in the new card language rather than
// collapsing and losing a field. And "any major health changes this year?"
// writes the `health_changes` boolean added for this step; its free-text
// follow-up rides on the existing `feedback_general` instead of a second
// column, which is why the general box's placeholder adapts below.
import CheckCardGroup from '../parts/CheckCardGroup.vue'

const HAPPY_OPTIONS = [
    { value: true, label: 'Happy with it' },
    { value: false, label: 'Not happy' },
]

const CHANGE_OPTIONS = [
    { value: false, label: 'No major changes' },
    { value: true, label: 'Yes, something changed' },
]

export default {
    components: { CheckCardGroup },
    props: {
        target: { type: Object, required: true },
    },
    computed: {
        happyOptions: () => HAPPY_OPTIONS,
        changeOptions: () => CHANGE_OPTIONS,
        // When the client says something changed, this box is where they say
        // what — so the prompt asks for it directly instead of staying generic.
        generalPlaceholder () {
            return this.target.health_changes
                ? 'A new diagnosis, surgery, hospital stay…'
                : "What's working, what isn't, and what you'll need next year"
        },
    },
    methods: {
        patch (deltas) {
            Object.entries(deltas).forEach(([k, v]) => { this.$set(this.target, k, v === '' ? null : v) })
        },
    },
}
